export const eventsData = [
  {
    id: 1,
    title: "Team Meeting",
    date: "2025-05-23",
    time: "09:00",
    duration: 2,
    description: "Weekly team sync and project updates"
  },
  {
    id: 2,
    title: "Client Presentation",
    date: "2025-05-23",
    time: "10:30",
    duration: 1.5,
    description: "Present Q2 results to key stakeholders"
  },
  {
    id: 3,
    title: "Lunch Break",
    date: "2025-05-23",
    time: "12:00",
    duration: 1,
    description: "Team lunch at the new restaurant"
  },
  {
    id: 4,
    title: "Code Review",
    date: "2025-05-24",
    time: "14:00",
    duration: 2,
    description: "Review PR #123 and discuss implementation"
  },
  {
    id: 5,
    title: "Workshop",
    date: "2025-05-25",
    time: "09:00",
    duration: 4,
    description: "React Advanced Patterns Workshop"
  },
  {
    id: 6,
    title: "1:1 Meeting",
    date: "2025-05-26",
    time: "15:00",
    duration: 1,
    description: "Weekly one-on-one with manager"
  },
  {
    id: 7,
    title: "Sprint Planning",
    date: "2025-05-27",
    time: "10:00",
    duration: 3,
    description: "Plan tasks for the next sprint"
  },
  {
    id: 8,
    title: "Coffee Chat",
    date: "2025-05-27",
    time: "11:00",
    duration: 1,
    description: "Casual coffee with the design team"
  },
  {
    id: 9,
    title: "Project Demo",
    date: "2025-05-28",
    time: "16:00",
    duration: 1,
    description: "Demo the new calendar feature"
  },
  {
    id: 10,
    title: "Team Retrospective",
    date: "2025-05-30",
    time: "14:00",
    duration: 2,
    description: "Reflect on the past sprint and identify improvements"
  },
  {
    id: 11,
    title: "Training Session",
    date: "2025-06-02",
    time: "09:00",
    duration: 3,
    description: "JavaScript ES6+ advanced features training"
  },
  {
    id: 12,
    title: "Client Call",
    date: "2025-06-03",
    time: "11:00",
    duration: 1,
    description: "Discuss project requirements and timeline"
  },
  {
    id: 13,
    title: "Design Review",
    date: "2025-06-04",
    time: "13:00",
    duration: 2,
    description: "Review new UI mockups and provide feedback"
  },
  {
    id: 14,
    title: "All Hands Meeting",
    date: "2025-06-05",
    time: "15:00",
    duration: 1,
    description: "Company-wide quarterly updates"
  },
  {
    id: 15,
    title: "Hackathon Prep",
    date: "2025-06-06",
    time: "10:00",
    duration: 4,
    description: "Prepare for the upcoming internal hackathon"
  }
];